import React, { useState, useEffect } from "react";
import "./Loader.css";

// Substitua pelo caminho correto do seu logo
import Logo from "../../assets/logo.png";

const Loader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simula o progresso de carregamento
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        // Incremento gradual
        const increment = Math.random() * 5 + 1; // Entre 1 e 6%
        return Math.min(100, oldProgress + increment);
      });
    }, 150);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        {/* Logo centralizado */}
        <img src={Logo} alt="Logo" className="loader-logo" />

        {/* Barra de progresso elegante */}
        <div className="progress-container">
          <div
            className="progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;